module.exports = __webpack_public_path__ + "img/114.6.35171e2b.png";